import * as React from 'react';
import { Button } from '@gandi/ui';
import { Static } from '../Static';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "pre": "Login-pre_3-cE1"
};
function Login({
  translator: {
    __
  },
  assetPath,
  locale,
  error,
  errorDescription,
  logoutLink = 'logout',
  tryAgainLink = 'login',
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Static, {
    title: __('Identification error'),
    illustration: assetPath('img/Login.svg'),
    buttons: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        href: tryAgainLink,
        kind: "outline",
        grouped: true,
        children: __('Try again')
      }), /*#__PURE__*/_jsx(Button, {
        href: logoutLink,
        grouped: true,
        children: __('Log out')
      })]
    }),
    ...extraProps,
    children: [errorDescription && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: __('Sorry, an identification error occurred. ' + 'This is probably a temporary error.')
      }), /*#__PURE__*/_jsx("p", {
        children: __('Please check the error messages below:')
      }), /*#__PURE__*/_jsxs("pre", {
        className: styles.pre,
        children: [/*#__PURE__*/_jsx("em", {
          children: error
        }), " ", errorDescription]
      })]
    }), !errorDescription && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: __('Sorry, an identification error occurred and we were unable to ' + "authenticate the server's response.")
      }), /*#__PURE__*/_jsx("p", {
        children: __('This is due to a malformed request, which could be a malicious ' + 'attempt to hijack your session. We recommend that you log out ' + 'as a precaution.')
      }), /*#__PURE__*/_jsx("p", {
        children: __('Please click one of the buttons below to try again or logout. ' + 'You can safely log in again afterwards.')
      })]
    })]
  });
}
export default Login;